import React from 'react'
import {
    styled,
    Box,
    Typography,
    InputBase,
    InputAdornment,
    useTheme,
} from '@mui/material'

import { Icon } from 'packages/eid-icons'
import {
    MUIDatePicker,
    NativeDatePicker,
} from 'packages/eid-ui/DateTimePickers'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

const DateTimeFilter = ({
    label,
    showLabelWithin,
    value,
    placeholder,
    onChange,
    disablePast,
    minDate,
    helperText,
}) => {
    const InputWithLabel = () => {
        const theme = useTheme()
        return (
            <Box>
                <Typography
                    style={{
                        color: '#b4b4b4',
                        fontSize: '10px',
                        textTransform: 'uppercase',
                        minWidth: '60px',
                        padding: '10px 10px',
                    }}
                >
                    {label}
                </Typography>
                <MUIDatePicker
                    dateFormat="D MMMM YYYY"
                    handleChange={(e) => {
                        onChange(e)
                    }}
                    value={value}
                    minDate={
                        minDate
                            ? minDate
                            : disablePast
                            ? moment(new Date())
                            : null
                    }
                    fieldProps={{
                        variant: 'outlined',
                        style: {
                            backgroundColor: theme?.palette?.common?.white,
                            width: '100%',
                            borderRadius: '5px',
                            color: '#5d6870 !important',
                        },
                        sx: {
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#ebebed',
                            },
                        },
                        placeholder: placeholder,

                        InputProps: {
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Icon name="Calendar" color="#959598" />
                                </InputAdornment>
                            ),
                            sx: {
                                height: '4.0rem !important',
                                fontSize: '1.6rem !important',
                            },
                        },
                        inputProps: {
                            style: {
                                color: '#5d6870',
                                paddingLeft: '10px',
                            },
                            readOnly: 'true',
                            'aria-label': label,
                        },
                    }}
                ></MUIDatePicker>
            </Box>
        )
    }

    const InputComponent = () => {
        const theme = useTheme()
        return (
            <MUIDatePicker
                dateFormat="D MMMM YYYY"
                handleChange={(e) => {
                    const date = moment(e)
                    onChange(date)
                }}
                value={value}
                minDate={
                    minDate ? minDate : disablePast ? moment(new Date()) : ''
                }
                customComponents={{
                    inputAdornment: () => {
                        return (
                            <InputAdornment position="end">
                                <Icon
                                    name="Tasks"
                                    width={19}
                                    height={20}
                                    color="#959598"
                                />
                            </InputAdornment>
                        )
                    },
                }}
                fieldProps={{
                    variant: 'outlined',
                    style: {
                        backgroundColor: theme?.palette?.common?.white,
                        width: '100%',
                        boxShadow: '0 2px 16px 0 rgba(0, 0, 0, 0.11)',
                        borderRadius: '5px',
                    },
                    sx: {
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#ebebed',
                        },
                    },
                    placeholder: placeholder,

                    InputProps: {
                        startAdornment: (
                            <InputAdornment position="start">
                                <Typography
                                    sx={{
                                        fontSize: '1rem !important',
                                        textTransform: 'uppercase',
                                        width: '6.5rem',
                                        whiteSpace: 'normal',
                                    }}
                                >
                                    {label}
                                </Typography>
                            </InputAdornment>
                        ),
                        sx: {
                            height: '4.3rem !important',
                            fontSize: '1.6rem !important',
                        },
                    },
                    inputProps: {
                        style: {
                            color: '#5d6870',
                            paddingLeft: '20px',
                        },
                        readOnly: 'true',
                        'aria-label': label,
                    },
                }}
            ></MUIDatePicker>
        )
    }

    return <>{showLabelWithin ? <InputComponent /> : <InputWithLabel />}</>
}

export default DateTimeFilter
